import React, { useState, useEffect } from 'react';
import { appliedRuleIcon, restartIcon, printIcon, readyCheckIcon } from "../../assets/images";
import { formatter, validate } from "../../utility";
import { Button } from 'react-bootstrap';
import { InputBase } from "../Helper/InputBase";
import { NormalizationConstants } from '../../constants';

const RICalcStepFour = (props) => {

  const { 
    calc_p2UnusedEligibleAmount, phase2RentAmount, calc_p2CPIValue, rentIncreaseDateAfterPhase2, 
    calc_p2AppliedEligibleAmount, calc_p2IsServiceTimeAvailable, isRentIncreaseAfterPhase2, calc_p2RemainingEligibleAmount,
    calc_p2RentIncreaseDate, calc_p2MinRentIncreaseDate, calc_p2MaxRentIncreaseDate, calc_isGeneratedNoticeAvailable
  } = props?.phaseTwoData;
  
  const print = () => {
    window.print();
  }

  const resetForm = () => {
    props?.resetPhaseTwo()
  }
  
  const renderUnusedEligibleAmountWarning = () => {
    if (calc_p2UnusedEligibleAmount <= 0 || !phase2RentAmount || phase2RentAmount <= 0) return;
    return <div className="validator__errors__error alert-error">
      <b>Warning.</b> The rent amount that you selected for the phase 2 additional rent increase does not use the full eligible amount available. Based on the rent amount entered of&nbsp;
      {formatter.toAmountDisplay(phase2RentAmount)}, you will lose {formatter.toAmountDisplay(calc_p2UnusedEligibleAmount)} of eligible amount which cannot be used in a future rent increase.
    </div>
  }

  const renderRemainingAmountRule = () => {
    return <p className="ric__rule">
      <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
      <span>
        <b>Applied Rule</b>: Any unused eligible amounts associated to a rental unit can be applied to a future rent increase.
        <span className="w1-step-three__rule--success">&nbsp;The remaining eligible amount for a future rent increase is&nbsp;<b>{formatter.toAmountDisplay(calc_p2RemainingEligibleAmount)}</b>.</span>
      </span>
    </p>
  }
  
  const renderLostAmountRule = () => {
    return <p className="ric__rule">
      <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
      <span>
        <b>Applied Rule</b>:
        <span className="w1-step-three__rule--error">
          &nbsp;If the phase 2 additional rent increase is not imposed between&nbsp;<b>{formatter.toDateDisplay(calc_p2MinRentIncreaseDate, { fullMonth: true })}</b>, and <b>{formatter.toDateDisplay(calc_p2MaxRentIncreaseDate, { fullMonth: true })}</b>,
          the eligible amount for phase 2 is lost and cannot be used in a future rent increase. The eligible amount remaining for the phase 3 additional rent increase would be {formatter.toAmountDisplay(calc_p2RemainingEligibleAmount)}.
        </span>
      </span>
    </p>
  }
  
  const renderRegularIncreaseConsideredAdditionalWarning = () => {
    if (!isRentIncreaseAfterPhase2) return;
    return <div className="validator__errors__error alert-error">
      <b>Warning.</b> Based on the additional rent increase regulations, the rent increase that was effective on {formatter.toDateDisplay(rentIncreaseDateAfterPhase2, { fullMonth: true })}, is considered the phase 2 additional rent increase. 
      If the phase 2 eligible amount of {formatter.toAmountDisplay(calc_p2AppliedEligibleAmount)} was not included in the rent increase on {formatter.toDateDisplay(rentIncreaseDateAfterPhase2, { fullMonth: true })}, then it is considered a lost amount and cannot be used for a future rent increase.
    </div>
  }

  const renderMissedDeadlineWithRemainingAmount = () => {
    if (!calc_p2IsServiceTimeAvailable && !isRentIncreaseAfterPhase2) {
      return <div className="validator__errors__error alert-error">
      <b>Warning.</b> Based on the information that you provided. the last allowed date for the second additional rent increase (phase 2) was {formatter.toDateDisplay(calc_p2RentIncreaseDate, { fullMonth: true })}. 
      As this date has passed, you have lost the right to impose the phase 2 additional rent increase and {formatter.toAmountDisplay(calc_p2AppliedEligibleAmount)} of eligible amount.&nbsp;
      <b>If you have any eligible amount remaining for a third rent increase (phase 3), you must generate a notice insert for this lost phase 2 rent increase and include it with your phase 3 additional rent increase</b>.
    </div>
    }
  }

  const renderNoEligibleAmountRemainingWarning = () => {
    if (calc_p2RemainingEligibleAmount) return;
    return <div className="validator__errors__error alert-error">
      <b>Warning.</b> Based on the rules and the information provided, you have {formatter.toAmountDisplay(calc_p2RemainingEligibleAmount)} eligible amount remaining for future rent increases. Only standard rent increases will be allowed for this rental unit going forward.
    </div>
  }

  return (
    <div className="ric__step-four">
      { calc_p2CPIValue ?
      <>
        { renderUnusedEligibleAmountWarning() }
        { renderRemainingAmountRule() }
        { renderLostAmountRule() }
        { renderRegularIncreaseConsideredAdditionalWarning() }
        { renderMissedDeadlineWithRemainingAmount() }
        { renderNoEligibleAmountRemainingWarning() }
      </> : null }
      <p className="w1-step-four__completed-text hide-print">
        <span className="validator__completed-text"><img className="w1-step-four__completed-text__icon" src={readyCheckIcon} alt=''/>Process Completed. {calc_isGeneratedNoticeAvailable ? 'If the above is information is correct you can use it to generate a rent increase notice insert.' : null}</span>
      </p>
      <div className="validator__print-container hide-print">
        { calc_isGeneratedNoticeAvailable ? <Button className="ric__step-four__button ric__generate-notice" variant="success" onClick={() => props?.toggleDisplayGeneratedNotice()}></Button> : null }
        <span className="w1-step-four__buttons__print" onClick={() => print()}>
          <img className="w1-step-four__buttons__print__icon" src={printIcon} alt='' /> <span>Print</span>
        </span>
        <span className="w1-step-four__buttons__restart" onClick={() => resetForm()}>
          <img className="w1-step-four__buttons__print__icon" src={restartIcon} alt='' /> <span className="ric__start-over-btn">Start Over</span>
        </span>
      </div>
    </div>
  )
}

export default RICalcStepFour;